<template>
    <div>
      <van-nav-bar
        title="资金明细"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/members')"
        class=""
      />
      <van-tabs v-model="active" animated @click="getListLog">
        <van-tab v-for="(item,index) in title" :title=item :key="index" >
          <van-divider></van-divider>
          <van-pull-refresh v-model="isLoading[index]" @refresh="onRefresh(active)">
            <!-- <van-loading v-if="showLoading" style="text-align: center;" /> -->
            <van-cell-group>
              <van-cell v-for="(item1,index1) in listLog[index]" :key="index1">
                <template #title>
                  {{ item1.name }}
                </template>
                <template #label>
                  {{ item1.time }}
                </template>
                <template #default>
                  <div v-if="item1.number">
                    <span class="red" v-if="(title[index] === '全部明细' || title[index] === '代金券') && Number(item1.number) >= 0">+{{ Number(item1.number).toFixed(2) }}元</span>
                    <span class="red" v-else-if="Number(item1.number) >= 0">{{ Number(item1.number).toFixed(2) }}元</span>
                    <span class="green" v-else>{{ Number(item1.number).toFixed(2) }}元</span>
                    <br>余额: {{ Number(item1.balance).toFixed(2) }}元
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-pull-refresh>
          <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
        </van-tab>
       
      </van-tabs>
      <CommonLoading ref="commonLoader"></CommonLoading>
    </div>
</template>

<script>
    import CommonLoading from "./CommonLoading";
    export default {
      name: "DetailedLog",
      components: {
        CommonLoading,
      },
      data(){
          return{
            active:0,
            title:['全部明细','充值明细','提现明细','借款明细','利润提取','管理费用','代金券','赠返现金'],
            methods:['all_log','recharge_log','withdraw_log','loan_log','extract_log','manage_log','vouchermanage_log','give_back'],
            isLoading:[false,false,false,false,false,false,false,false],
            listLog:[
              [],[],[],[],[],[],[],[],
            ],
            showLoading:false,
          }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
       },
        getListLog(name){
          let that = this;
          if (that.listLog[name].length === 0){
            // that.showLoading=true;
            that.$refs.commonLoader.showCommonLoadigIcon();
            if (name === 7){
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: 'all_log',
                  token: sessionStorage.getItem("token"),
                  type:14
                }
              })
                .then(function(res) {
                  // that.showLoading=false;
                  that.$refs.commonLoader.hideCommonLoadigIcon();
                  let resData = res.data;
                  if (resData.code === 1) {
                    if (resData.data.length === 0){
                      that.addData(name,resData.data)
                    }else{
                      that.$set(that.listLog,name,resData.data);
                    }
                    // that.listLog[name] = resData.data;
                  } else if (resData.code === 0) {
                    that.$toast.fail(resData.msg);
                  }
                });
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: that.methods[name],
                  token: sessionStorage.getItem("token")
                }
              })
                .then(function(res) {
                  // that.showLoading=false;
                  that.$refs.commonLoader.hideCommonLoadigIcon();
                  let resData = res.data;
                  if (resData.code === 1) {
                    switch (name) {
                      case 1:
                      case 2:
                        if (resData.data.data.length === 0){
                          that.addData(name,resData.data.data)
                        }else{
                          that.$set(that.listLog,name,resData.data.data);
                        }
                        break;
                      default:
                        if (resData.data.length === 0){
                          that.addData(name)
                        }else{
                          that.$set(that.listLog,name,resData.data);
                        }
                        break;
                    }
                  } else if (resData.code === 0) {
                    that.$toast.fail(resData.msg);
                  }
                });
            }
          }
        },
        addData(name,data){
          let that = this;
          that.$set(that.listLog,name,[{
            name: "暂无数据",
            number: "0",
            balance: "0",
            time: "暂无数据",
          }]);
        },
        onRefresh(name){
          let that = this;
          if (name === 7){
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_log',
                token: sessionStorage.getItem("token"),
                type:14
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  if (resData.data.length === 0){
                    that.addData(name,resData.data)
                  }else{
                    that.$set(that.listLog,name,resData.data);
                  }
                  // that.listLog[name] = resData.data;
                } else if (resData.code === 0) {
                  that.$toast.fail(resData.msg);
                }
              });
          }else{
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: that.methods[name],
                token: sessionStorage.getItem("token")
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  switch (name) {
                    case 1:
                    case 2:
                      if (resData.data.data.length === 0){
                        that.addData(name,resData.data.data)
                      }else{
                        that.$set(that.listLog,name,resData.data.data);
                      }
                      break;
                    default:
                      if (resData.data.length === 0){
                        that.addData(name)
                      }else{
                        that.$set(that.listLog,name,resData.data);
                      }
                      break;
                  }
                } else if (resData.code === 0) {
                  that.$toast.fail(resData.msg);
                }
              });
          }
        },
      },
      mounted:function () {
        this.isLogin();
        if(this.$route.params.tab){
          this.active = parseInt(this.$route.params.tab);
          this.getListLog(this.active);
        }else{
          this.getListLog(0);
        }
      },
    }
</script>

<style scoped>
  /deep/ .van-tab--active {
    color: #D02E27 !important;
  }
  /deep/.van-cell__label{
    font-size: 12px;
  }
  /deep/.van-cell__title{
    font-size: 14px;
  }
  /deep/.van-cell__value{
    font-size: 14px;
  }
  /deep/.van-cell::after {
    content: "";
    display: block;
    height: 1px;
    background-color: #f0f0f0; 
  }
  /deep/.van-divider {
    content: "";
    display: block;
    height: 1px;
    background-color: #f0f0f0; 
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 0px;
    margin-bottom: -1px;
    padding: 1px;
  }
  /deep/.van-tabs__line {
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 1;
    width: 40px;
    height: 3px;
    background-color: #D02E27 !important;
    border-radius: 3px;
}

  .red{
    color: #D02E27;
  }
  .green{
    color: #3F7A21;
  }
  .navStyle{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailedLog.vue